<template>
  <div class="case-order-detail flow">
    <div class="header">
      <i
        class="icon icon-fanhuijiantou"
        @click="jump(-1)"
      ></i>
      <div class="title">
        {{orderType === 'caseOrder' ? $t('asm_case_order_detail.gong_dan_hao') : $t('asm_case_order_detail.gong_dan_bian_hao')}}：{{orderType === 'caseOrder' ? info.caseOrderCode : info.workOrderCode }}
      </div>
      <div class="btn-content">
        <!-- 类型/案例订单 start -->
        <!-- 受理案例 -->
        <el-button
          type="primary"
          v-if="showBtnAccept"
          @click="onAccept"
        >{{$t('asm_case_order_detail.shou_li')}}</el-button>
        <!-- 关闭案例订单 -->
        <el-button
          type="primary"
          v-if="showBtnClose"
          @click="onClose"
        >{{ $t('asm_case_order_detail.qu_xiao_ding_dan') }}</el-button>
        <!-- 分派工单 -->
        <el-button
          type="primary"
          v-if="showBtnAssign"
          @click="assignWorkOrder"
        >{{ $t('asm_case_order_detail.fpgcs') }}</el-button>
        <!-- 重新分派 -->
        <el-button
          type="primary"
          v-if="showBtnReAssign"
          @click="reAssignWorkOrder"
        >{{ $t('asm_case_order_detail.zai_ci_fen_pai') }}</el-button>
        <!-- 类型/案例订单 end -->

        <!-- 类型/工单 start -->
        <!-- 开始返工 -->
        <el-button
          type="primary"
          v-if="showBtnStartRework"
          @click="onStartRework"
        >{{$t('asm_case_order_detail.kai_shi_fan_gong')}}</el-button>
        <!-- 接单 -->
        <el-button
          type="primary"
          v-if="showBtnAcceptOrder && isCurOrder"
          @click="acceptWorkOrder"
        >{{$t('asm_case_order_detail.jie_dan')}}</el-button>
        <!-- 关闭工单(转至主管) -->
        <el-button
          type="primary"
          v-if="showBtnCloseOrder && isCurOrder"
          @click="closeWorkOrder"
        >{{ $t('asm_case_order_detail.zhuan_zhi_zhu_guan') }}</el-button>
        <!-- 转派工单  -->
        <el-button
          type="primary"
          v-if="showBtnTransfer && isCurOrder"
          @click="transferWorkOrder"
        >{{ $t('asm_case_order_detail.zhuan_dan') }}</el-button>
        <!-- {{funcView}} -->
        <!-- 质量反馈 -->
        <el-button
          type="primary"
          v-if="showBtnFeedBack"
          @click="feedBackWorkOrder"
        >{{funcView.work_order_detail_feeback}}</el-button>
        <!-- 现场解决 -->
        <el-button
          v-if="onsiteSolveBtnDisplay"
          type="primary"
          @click="onsiteSolve"
        >{{funcView.work_order_detail_onsite_solve}}</el-button>
        <!-- 类型/工单 end -->
      </div>
    </div>
    <div class="user-info-content">
      <div class="header">
        <div class="user-info">
          <div class="user-icon"></div>
          <div class="user-text-info">
            <!-- 查看案例-维修 报修人信息  creator/contactPhone  orgName -->
            <!-- 查看案例-保养：
              1. 系统创建的：乙方的项目负责人/负责人联系电话：projectContactName  projectContactPhone
              2. 人工创建的：创建时的：联系人/联系电话    contactName  contactPhone orgName
            -->
            <template v-if="isCaseOrder">
              <div
                class="param-item"
                v-if="info.caseOrderType === 10"
              >
                <div class="key">{{info.orgName}}</div>
                <div class="val">{{info.creator}} {{info.contactPhone}}</div>
              </div>
              <template v-else>
                <div
                  class="param-item"
                  v-if="info.caseOrderSource !== 9"
                >
                  <div class="key">{{info.orgName}}</div>
                  <div class="val">{{info.contactName}} {{info.contactPhone}}</div>
                </div>
                <div
                  class="param-item"
                  v-else
                >
                  <div class="key">{{info.projectContactName}}</div>
                  <div class="val">{{info.projectContactPhone}}</div>
                </div>
              </template>
            </template>
            <!-- 查看工单-维修,保养：最新已接单的售后工程师 technicianName (technicianOrgName) technicianPhone -->
            <template v-else>
              <div class="param-item">
                <div class="key">{{info.technicianOrgName}}</div>
                <div class="val">{{info.technicianName}} {{info.technicianPhone}}</div>
              </div>
            </template>
          </div>
        </div>
        <div class="param-content">
          <!-- 案例订单-维修 / 案例订单-保养 / 案例订单-返修 -->
          <ul
            class="param-list"
            v-if="isCaseOrder"
          >
            <li class="item text-right">
              <div class="param-item">
                <div class="key">{{ $t('asm_case_order_detail.fu_wu_lei_bie') }}</div>
                <div class="val">{{ getDicValue('asm_case_order_service_class',info.caseOrderType)}}</div>
              </div>
            </li>
            <li
              class="item text-right"
              v-if="isReworkOrder"
            >
              <div class="param-item">
                <div class="key">{{$t('asm_case_order_detail.fan_gong_ban_ben')}}</div>
                <div class="val">{{ info.caseOrderDesc || '-' }}</div>
              </div>
            </li>
            <li class="item text-right">
              <div class="param-item">
                <div class="key">{{ $t('asm_case_order_detail.ding_dan_zhuang_tai') }}</div>
                <div class="val">{{ getDicValue('asm_case_order_state',info.caseOrderState) }}</div>
              </div>
            </li>
            <li class="item text-right">
              <div class="param-item">
                <div class="key">{{ $t('asm_case_order_detail.lai_yuan') }}</div>
                <div class="val">{{ getDicValue('asm_case_order_source',info.caseOrderSource)}}</div>
              </div>
            </li>
            <li class="item text-right">
              <div class="param-item">
                <div class="key">{{$t('asm_case_order_detail.chuang_jian_fang_shi')}}</div>
                <div class="val">{{ getDicValue('asm_case_order_create_mode',info.createMode)}}</div>
              </div>
            </li>
            <!-- 小程序没绑定用户或者H5的时候是没有这个创建人，那就显示联系人 -->
            <li
              class="item text-right"
              v-if="info.creator || info.contactName"
            >
              <div class="param-item">
                <div class="key">{{ $t('asm_case_order_detail.shang_bao_ren') }}</div>
                <div class="val">{{info.creator || info.contactName}}</div>
              </div>
            </li>
            <li class="item text-right">
              <div class="param-item">
                <div class="key">{{$t('asm_case_order_detail.shang_bao_shi_jian')}}</div>
                <div class="val">{{$momentLocal(info.gmtCreate)}}</div>
              </div>
            </li>
          </ul>

          <!-- 工单管理-维修 / 工单管理-保养  / 工单管理-返修 -->
          <ul
            class="param-list"
            v-if="!isCaseOrder"
          >
            <li class="item text-right">
              <div class="param-item">
                <div class="key">{{$t('asm_case_order_detail.gong_dan_lei_xing')}}</div>
                <div class="val">{{ getDicValue('asm_case_order_service_class',info.caseOrderType)}}</div>
              </div>
            </li>
            <li
              class="item text-right"
              v-if="isReworkOrder"
            >
              <div class="param-item">
                <div class="key">{{$t('asm_case_order_detail.fan_gong_ban_ben')}}</div>
                <div class="val">{{info.caseOrderDesc || '-'}}</div>
              </div>
            </li>
            <li class="item text-right">
              <div class="param-item">
                <div class="key">{{$t('asm_case_order_detail.gong_dan_zhuang_tai')}}</div>
                <div class="val">{{ getDicValue('asm_work_order_state', state) }}</div>
              </div>
            </li>
            <li class="item text-right">
              <div class="param-item">
                <div class="key">{{ $t('asm_case_order_detail.lai_yuan') }}</div>
                <div class="val">{{ getDicValue('asm_case_order_source',info.caseOrderSource) }}</div>
              </div>
            </li>
            <li class="item text-right">
              <div class="param-item">
                <div class="key">{{$t('asm_case_order_detail.chuang_jian_fang_shi')}}</div>
                <div class="val">{{ getDicValue('asm_case_order_create_mode',info.createMode)}}</div>
              </div>
            </li>
            <li class="item text-right">
              <div class="param-item">
                <div class="key">{{ $t('asm_case_order_detail.shang_bao_ren') }}</div>
                <div class="val">{{info.contactName}}</div>
              </div>
            </li>
            <li class="item text-right">
              <div class="param-item">
                <div class="key">{{$t('asm_case_order_detail.shang_bao_shi_jian')}}</div>
                <div class="val">{{$momentLocal(info.gmtCreate)}}</div>
              </div>
            </li>
            <!-- 服务方式 -->
            <li
              class="item text-right"
              v-if="!isReworkOrder"
            >
              <div class="param-item">
                <div class="key">{{$t('asm_case_order_detail.xian_chang_jie_jue')}}</div>
                <div class="val">{{getDicValue('isynergy_cloud_bool', info.isOnsiteArrived)}}</div>
              </div>
            </li>
            <!-- WiFi定位 -->
            <li
              class="item text-right"
              v-if="!isReworkOrder"
            >
              <div class="param-item">
                <div class="key">{{$t('asm_case_order_detail.WiFiding_wei')}}</div>
                <div class="val">{{getDicValue('isynergy_cloud_bool', info.isOnsiteWifi)}}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="bar-content">
        <service-process-bar
          :orderType="orderType"
          :state="state"
        ></service-process-bar>
      </div>
      <!-- <div
        class="order-desc"
        v-if="info.caseOrderDesc"
      >
        <div class="key">{{$t('label_case_order_desc')}}：</div>
        <div class="val">{{info.caseOrderDesc}}</div>
      </div> -->

    </div>
    <div class="content">
      <div class="device-param">
        <div class="header">
          <div class="device-sn">{{ info.productCode }}</div>
        </div>
        <div
          class="device-img"
          :class="{ gray: !curProductImg }"
        >
          <img
            :src="curProductImg"
            alt
            v-if="curProductImg"
          />
        </div>
        <ul class="param-detail">
          <!-- 产品型号主图未显示，品牌无需显示 -->
          <!-- <li v-if="curProductImg">
            <div class="content">
              <div class="key">
                {{$t('label_product_brand')}}
              </div>
              <div class="val">{{info.productBrand || '-'}}</div>
            </div>
          </li> -->
          <li>
            <div class="content">
              <div class="key">
                {{ $t('asm_case_order_detail.ji_shen_hao') }}
              </div>
              <div class="val">{{info.bodyNum || '-'}}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{'Modem SN'}}
              </div>
              <div class="val">{{info.modemSn || '-'}}</div>
            </div>
          </li>
          <li v-if="isReworkOrder">
            <div class="content">
              <div class="key">
                {{$t('asm_case_order_detail.fan_gong_ban_ben')}}
              </div>
              <div class="val">{{info.machineVersion || '-'}}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('asm_case_order_detail.she_bei_ming_cheng') }}
              </div>
              <div class="val">{{info.deviceName || '-'}}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{$t('asm_case_order_detail.ye_wu_lei_xing')}}
              </div>
              <div class="val">{{info.deviceBizType || '-'}}</div>
            </div>
          </li>
          <!-- 业务状态 -->
          <li>
            <div class="content">
              <div class="key">
                {{ $t('asm_case_order_detail.ye_wu_zhuang_tai') }}
              </div>
              <div class="val">{{getDicValue('order_device_biz_state', info.bizState) || '-'}}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('asm_case_order_detail.he_tong_bian_hao') }}
              </div>
              <div class="val">{{info.contractNo || '-'}}</div>
            </div>
          </li>
          <!-- 订单类型 -->
          <li>
            <div class="content">
              <div class="key">
                {{ $t('asm_case_order_detail.ding_dan_lei_xing') }}
              </div>
              <div class="val">{{getDicValue('crm_contract_type', info.orderType) || '-'}}</div>
            </div>
          </li>
          <!-- <li>
            <div class="content">
              <div class="key">
                {{$t('label_use_address')}}
              </div>
              <div class="val">{{info.useAddress || '-'}}</div>
            </div>
          </li> -->

          <li>
            <div class="content">
              <div class="key">
                {{ $t('asm_case_order_detail.dai_li_gong_si') }}
              </div>
              <div class="val">{{info.agentCoName || '-'}}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{$t('asm_case_order_detail.shou_hou_gong_si')}}
              </div>
              <div class="val">{{info.afterServiceName || '-'}}</div>
            </div>
          </li>
          <!-- 服务开始日期  -->
          <li>
            <div class="content">
              <div class="key">
                {{$t('asm_case_order_detail.fu_wu_kai_shi_ri_qi')}}
              </div>
              <div class="val">{{$momentLocal(info.rentalStartTime, 'YYYY-MM-DD') || '-'}}</div>
            </div>
          </li>
          <!-- 服务结束日期 -->
          <li>
            <div class="content">
              <div class="key">
                {{ $t('asm_case_order_detail.fu_wu_jie_shu_ri_qi') }}
              </div>
              <div class="val">{{$momentLocal(info.rentalEndTime, 'YYYY-MM-DD') || '-'}}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('asm_case_order_detail.zu_lin_fang') }}
              </div>
              <div class="val">{{info.customerName || '-'}}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('asm_case_order_detail.xiang_mu') }}
              </div>
              <div class="val">{{info.locationName || '-'}}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('asm_case_order_detail.qu_yu') }}
              </div>
              <div class="val">{{info.siteName || '-'}}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('asm_case_order_detail.fu_wu_di_zhi') }}
              </div>
              <div class="val">{{info.addressView || '-'}}</div>
            </div>
          </li>
        </ul>
      </div>
      <div class="tab-container">
        <custom-tab
          :list="tabData"
          v-model="tabIndex"
        ></custom-tab>
        <div class="tab-content">
          <!-- 服务内容 -->
          <service-content
            v-if="tabIndex === 'service_content'"
            :caseOrderId="info.caseOrderId"
            :orderType="orderType"
            :caseOrderType="caseOrderType"
            @update="getInfo"
          ></service-content>
          <!-- 工单内容 -->
          <service-content
            v-if="tabIndex === 'work_order_content'"
            :caseOrderId="info.caseOrderId"
            :orderType="orderType"
            :caseOrderType="caseOrderType"
            @update="getInfo"
          ></service-content>
          <!-- 返工项 -->
          <rework-items v-if="tabIndex === 'rework_items'"></rework-items>
          <!-- 建议处理方案 -->
          <case-proposal
            v-if="tabIndex === 'case_proposal'"
            :orderDeviceId="info.orderDeviceId"
            :orderType="orderType"
            :caseOrderType="caseOrderType"
          ></case-proposal>
          <!-- 建议携带零件 -->
          <proposal-carry-part
            v-if="tabIndex === 'proposal_carry_part'"
            :orderDeviceId="info.orderDeviceId"
            :caseOrderId="info.caseOrderId"
            :orderType="orderType"
            :caseOrderType="caseOrderType"
          ></proposal-carry-part>
          <!-- 处理记录 -->
          <handle-record
            v-if="tabIndex === 'handle_record'"
            :caseOrderId="info.caseOrderId"
            :orderType="orderType"
            :caseOrderType="caseOrderType"
          ></handle-record>
          <!-- 服务动态 -->
          <service-dynamic
            v-if="tabIndex === 'service_dynamic'"
            :caseOrderId="info.caseOrderId"
            :orderType="orderType"
            :caseOrderType="caseOrderType"
          ></service-dynamic>
          <!-- 工单动态 -->
          <service-dynamic
            v-if="tabIndex === 'work_order_dynamic'"
            :info="info"
            :caseOrderId="info.caseOrderId"
            :workOrderId="info.workOrderId"
            :orderType="orderType"
            :caseOrderType="caseOrderType"
          ></service-dynamic>
          <!-- 建议更换零件 -->
          <suggest-replace-part v-if="tabIndex === 'suggest_replace_part'"></suggest-replace-part>
          <!-- 保养项目 -->
          <maintenance-item
            v-if="tabIndex === 'maintenance_item'"
            :caseOrderId="info.caseOrderId"
            :orderDeviceId="info.orderDeviceId"
            :orderTechnicianId="info.orderTechnicianId"
            :workOrderId="info.workOrderId"
            :orderType="orderType"
            :caseOrderType="caseOrderType"
          ></maintenance-item>
        </div>
      </div>
    </div>
    <acceptance-comments-dialog
      v-if="acceptanceCommentsVisible"
      @close="acceptanceCommentsVisible=false"
      :model="acceptanceCommentsModel"
      :type="acceptanceCommentsModel.type"
      @success="onSuccess"
    ></acceptance-comments-dialog>
    <!-- 分派工单 -->
    <assign-work-order-dialog
      v-if="assignWorkOrderVisible"
      @close="assignWorkOrderVisible = false"
      :model="assignWorkOrderModel"
      @success="onSuccess"
      :isTransfer="isTransfer"
      :isRework="isReworkOrder"
    ></assign-work-order-dialog>
    <!-- 质量反馈 isExistPartReplace-->
    <feedBack-add-dialog
      v-if="feedBackVisible"
      @close="feedBackVisible = false"
      :model="feedBackModel"
      @success="onSuccess"
    ></feedBack-add-dialog>
    <!-- 质量反馈 新建-->
    <feedBack-item-dialog
      v-if="feedBackVisible1"
      @close="feedBackVisible1 = false"
      :model="feedBackModel1"
      @success="onSuccess"
    ></feedBack-item-dialog>
    <!-- 开始返工 -->
    <start-rework-dialog
      v-if="startReworkVisible"
      @close="startReworkVisible = false"
      :model="startReworkModel"
      @success="onSuccess"
    ></start-rework-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import feedBackItemDialog from '@/pages/asm/components/feedBack_item_dialog';
import serviceProcessBar from './children/service_process_bar';
import acceptanceCommentsDialog from './children/acceptance_comments_dialog';
import serviceContent from './children/service_content';
import caseProposal from './children/case_proposal';
import proposalCarryPart from './children/proposal_carry_part';
import handleRecord from './children/handle_record';
import serviceDynamic from './children/service_dynamic';
import assignWorkOrderDialog from './children/assign_work_order_dialog';
import suggestReplacePart from './children/suggest_replace_part';
import maintenanceItem from './children/maintenance_item';
import feedBackAddDialog from './children/feedBack_add_dialog';
import reworkItems from './children/rework_items.vue';
import startReworkDialog from './children/start_rework_dialog.vue';

function getDefaultInfo() {
  return {
    // 优先级
    priority: '',
    caseOrderCode: '',
    workOrderCode: '',
    caseOrderType: '',
    orgName: '',
    creator: '',
    contactPhone: '',
    caseOrderSource: '',
    contactName: '',
    projectContactName: '',
    projectContactPhone: '',
    technicianOrgName: '',
    technicianName: '',
    technicianPhone: '',
    caseOrderState: '',

    createMode: '',
    gmtCreate: '',
    planFinishTime: '',
    caseOrderDesc: '',
    productCode: '',
    productBrand: '',
    bodyNum: '',
    modemSn: '',
    contractNo: '',
    useAddress: '',
    locationName: '',
    agentCoName: '',
    afterServiceName: '',
    customerName: '',
    orderDeviceId: '',

  };
}

export default {
  name: 'caseOrderDetail',
  provide() {
    return {
      getCaseInfo: () => this.info,
      // 案例订单 分配给售后工程师后，订单中的操作功能将不可用
      checkActionEnable: function () {
        if (this.info) {
          if (this.orderType === 'caseOrder' && this.info.caseOrderState >= 40) {
            return false;
          }
        }
        return true;
      }
    };
  },
  mixins: [],
  components: {
    serviceProcessBar,
    acceptanceCommentsDialog,
    serviceContent,
    caseProposal,
    handleRecord,
    serviceDynamic,
    proposalCarryPart,
    assignWorkOrderDialog,
    suggestReplacePart,
    maintenanceItem,
    feedBackAddDialog,
    feedBackItemDialog,
    reworkItems,
    startReworkDialog
  },
  props: {},
  data() {
    return {
      info: getDefaultInfo(),
      acceptanceCommentsVisible: false,
      acceptanceCommentsModel: {},
      caseOrderId: '',
      workOrderId: '',
      tabIndex: '',
      imgList: [],
      assignWorkOrderVisible: false,
      assignWorkOrderModel: {},
      // 维修类型: 案例订单：caseOrder，工单：workOrder
      orderType: '',
      // 工单类型：caseOrderType 10-维修，20-保养，30-培训，40-安装 50 - 返工
      caseOrderType: '',
      isTransfer: false,
      isPersonal: false,
      isExistPartReplace: false,
      feedBackVisible: false,
      feedBackModel: {},
      feedBackVisible1: false,
      feedBackModel1: {},
      // 开始返工
      startReworkVisible: false,
      startReworkModel: {},
    };
  },
  computed: {
    // 判断serviceMethod是否能展示,因为可能这个字段是空
    // serviceMethodDisplay() {
    //   const info = this.info;
    //   if (info) {
    //     if (info.serviceMethod === undefined || info.serviceMethod === '') {
    //       return false;
    //     }
    //     return true;
    //   }

    //   return false;
    // },
    // 判断 现场解决 按钮是否能展示
    onsiteSolveBtnDisplay() {
      if (!this.funcView.work_order_detail_onsite_solve) {
        return false;
      }
      const info = this.info;
      const userInfo = this.$store.state.userInfo || {};

      if (!userInfo.rootOrgId) {
        return false;
      }

      // 当前登录人的所属组织 与工单的售后公司 一致
      const isSameOrg = info.afterServiceId === userInfo.rootOrgId;

      if (info) {
        if (info.isOnsiteArrived === undefined || info.isOnsiteArrived === '' || !info.orderTechnicianId) {
          return false;
        }
        return `${info.isOnsiteArrived}` === '0' && `${info.serviceMethod}` === '1' && isSameOrg;
      }
      return false;
    },
    // 当前的工单是登录人的工单,todo
    isCurOrder() {
      const userInfo = this.$store.state.userInfo;
      const info = this.info;
      const { technicianId } = info;
      const { userId } = userInfo;
      if (!technicianId) {
        return true;
      } else {
        return userId === technicianId;
      }
    },
    state() {
      if (this.orderType === 'caseOrder') {
        return this.info.caseOrderState;
      } else {
        if (this.isPersonal) {
          return this.info.technicianWorkOrderState || this.info.workOrderState;
        } else {
          return this.info.workOrderState;
        }
      }
    },
    // 是否为售后客服
    // isAfterSaleService(){
    //   const userInfo = this.$store.state.userInfo;
    //   if(userInfo){
    //     return userInfo.bizType === ''
    //   }
    //   return false;
    // },
    // 是否为案例订单
    isCaseOrder() {
      return this.orderType === 'caseOrder';
    },
    // 是否为维修单
    isRepairOrder() {
      return `${this.caseOrderType}` === '10';
    },
    // 是否为返修单
    isReworkOrder() {
      return `${this.caseOrderType}` === '50';
    },
    // 显示按钮：受理案例
    showBtnAccept() {
      if (!this.funcView.case_order_detail_accept) {
        return false;
      }
      // 案例订单-待受理 20
      return this.orderType === 'caseOrder' ? this.info.caseOrderState === 20 : false;
    },
    // 显示按钮：开始返工
    showBtnStartRework() {
      if (!this.funcView.work_order_detail_start_rework) {
        return false;
      }
      if (!this.isReworkOrder) {
        return false;
      }
      const stateValidate = (this.info.workOrderState > 40 && this.info.workOrderState < 90);
      const userInfo = this.$store.state.userInfo;
      if (!userInfo) {
        return false;
      }
      const userId = userInfo.userId;
      return stateValidate && userId === this.info.technicianId;
    },
    // 显示按钮：接单
    showBtnAcceptOrder() {
      if (!this.funcView.work_order_detail_accept) {
        return false;
      }
      // 工单-待接单 40
      return this.orderType === 'workOrder' ? this.info.workOrderState === 40 : false;
    },
    // 显示按钮：关闭案例订单
    showBtnClose() {
      if (!this.funcView.case_order_detail_close) {
        return false;
      }
      return this.orderType === 'caseOrder' ? (this.info.caseOrderState >= 20 && this.info.caseOrderState <= 70) : false;

    },
    // 显示按钮：关闭工单
    showBtnCloseOrder() {
      if (!this.funcView.work_order_detail_close) {
        return false;
      }
      // 状态>=待接单且状态<=已到达
      return this.orderType === 'workOrder' ? [40, 50, 60, 70].includes(this.info.workOrderState) : false;
    },
    // 显示按钮：分派工单
    showBtnAssign() {
      if (!this.funcView.case_order_detail_transfer) {
        return false;
      }
      return this.orderType === 'caseOrder' ? this.info.caseOrderState === 30 : false;
    },
    // 显示按钮：重新分派
    showBtnReAssign() {
      if (!this.funcView.case_order_detail_reTransfer) {
        return false;
      }
      return this.orderType === 'caseOrder' ? [90, 91].includes(this.info.caseOrderState) : false;
    },
    // 显示按钮：转派工单
    showBtnTransfer() {
      if (!this.funcView.work_order_detail_transfer) {
        return false;
      }
      // 状态>=待接单且状态<=已到达
      return this.orderType === 'workOrder' ? [40, 50, 60, 70].includes(this.info.workOrderState) : false;
    },
    // 显示按钮：质量反馈
    showBtnFeedBack() {
      if (!this.funcView.work_order_detail_feeback) {
        return false;
      }
      const userInfo = this.$store.state.userInfo;
      // return true;
      // 只要是工单就会有 [90, 100].includes(this.info.workOrderState)
      // 售后公司同一个人才显示userInfo.rootOrgId === this.info.afterServiceId
      return this.orderType === 'workOrder' && userInfo.rootOrgId === this.info.afterServiceId;
    },
    tabData() {
      /**
       * 案例-维修：服务内容，建议处理方案，建议携带零件，处理记录，服务动态
       * 案例-保养：服务内容，保养项目，建议更换零件，处理记录，服务动态
       =>
         案例-维修：故障信息，故障处理建议，建议携带零件，工单分派记录，订单跟踪
         案例-保养：故障信息，保养项目，建议更换零件，工单分派记录，订单跟踪
       *
       * 工单-维修：工单内容，建议处理方案，建议携带零件，处理记录，处理路线，工单动态
       * 工单-保养：工单内容，保养项目，建议更换零件，处理记录，处理路线，工单动态
       =>
         工单-维修：故障信息，故障处理建议，建议携带零件，处理记录，工单跟踪
         工单-保养：故障信息，保养项目，建议更换零件，处理记录，工单跟踪


         案例-返修：服务内容，返工项，工单分派记录，订单跟踪

       */
      let ret = [];
      // 维修单
      if (this.isReworkOrder) {
        // 案例订单
        if (this.orderType === 'caseOrder') {
          ret.push(
            {
              name: this.$t('asm_case_order_detail.fu_wu_nei_rong'),
              value: 'service_content',
              role: 'case_order_fault_msg'
            },


          );

          if (this.funcView.case_order_detail_rework_items) {
            ret.push(
              // 返工项
              {
                name: this.funcView.case_order_detail_rework_items,
                value: 'rework_items',
                role: 'case_order_detail_rework_items'
              },
            );
          }

          ret.push(
            {
              name: this.$t('asm_case_order_detail.gdfpjl'),
              value: 'handle_record',
              role: 'case_order_order_assign_record'
            },
            {
              name: this.$t('asm_case_order_detail.ding_dan_gen_zong'),
              value: 'service_dynamic',
              role: 'case_order_order_tracking'
            },
          );
        } else {
          // 工单
          ret.push(
            {
              name: this.$t('asm_case_order_detail.fu_wu_nei_rong'),
              value: 'work_order_content',
              role: 'work_order_fault_msg'
            },


          );

          if (this.funcView.work_order_detail_rework_items) {
            ret.push(
              // 返工项
              {
                name: this.funcView.work_order_detail_rework_items,
                value: 'rework_items',
                role: 'work_order_detail_rework_items',
              },
            );
          }

          ret.push(
            {
              name: this.$t('asm_case_order_detail.chu_li_ji_lu'),
              value: 'handle_record',
              role: 'work_order_handle_record'
            },
            {
              name: this.$t('asm_case_order_detail.gong_dan_gen_zong'),
              value: 'work_order_dynamic',
              role: 'work_order_order_tracking'
            },
          );

        }

      } else {
        // 案例订单
        if (this.orderType === 'caseOrder') {
          // 维修
          if (`${this.caseOrderType}` === '10') {
            ret = [
              {
                name: this.$t('asm_case_order_detail.gu_zhang_xin_xi'),
                value: 'service_content',
                role: 'case_order_fault_msg'
              },
              {
                name: this.$t('asm_case_order_detail.gzcljy'),
                value: 'case_proposal',
                role: 'case_order_fault_handle_suggest'
              },
              {
                name: this.$t('asm_case_order_detail.jyxdlj'),
                value: 'proposal_carry_part',
                role: 'case_order_suggest_carry_part'
              },
              {
                name: this.$t('asm_case_order_detail.gdfpjl'),
                value: 'handle_record',
                role: 'case_order_order_assign_record'
              },
              {
                name: this.$t('asm_case_order_detail.ding_dan_gen_zong'),
                value: 'service_dynamic',
                role: 'case_order_order_tracking'
              },
            ];
          } else {
            // 保养
            ret = [
              {
                name: this.$t('asm_case_order_detail.gu_zhang_xin_xi'),
                value: 'service_content',
                role: 'case_order_fault_msg'
              },
              {
                name: this.$t('asm_case_order_detail.bao_yang_xiang_mu'),
                value: 'maintenance_item',
                role: 'case_order_maintain_project'
              },
              {
                name: this.$t('asm_case_order_detail.jyghlj'),
                value: 'suggest_replace_part',
                role: 'case_order_suggest_replace_part'
              },
              {
                name: this.$t('asm_case_order_detail.gdfpjl'),
                value: 'handle_record',
                role: 'case_order_order_assign_record'
              },
              {
                name: this.$t('asm_case_order_detail.ding_dan_gen_zong'),
                value: 'service_dynamic',
                role: 'case_order_order_tracking'
              },
            ];
          }

          // 工单
        } else {
          // 维修
          if (`${this.caseOrderType}` === '10') {
            ret = [
              {
                name: this.$t('asm_case_order_detail.gu_zhang_xin_xi'),
                value: 'work_order_content',
                role: 'work_order_fault_msg'
              },
              {
                name: this.$t('asm_case_order_detail.gzcljy'),
                value: 'case_proposal',
                role: 'work_order_fault_handle_suggest'
              },
              {
                name: this.$t('asm_case_order_detail.jyxdlj'),
                value: 'proposal_carry_part',
                role: 'work_order_suggest_carry_part'
              },
              {
                name: this.$t('asm_case_order_detail.chu_li_ji_lu'),
                value: 'handle_record',
                role: 'work_order_handle_record'
              },
              {
                name: this.$t('asm_case_order_detail.gong_dan_gen_zong'),
                value: 'work_order_dynamic',
                role: 'work_order_order_tracking'
              },
            ];
          } else {
            // 保养
            ret = [
              {
                name: this.$t('asm_case_order_detail.gu_zhang_xin_xi'),
                value: 'work_order_content',
                role: 'work_order_fault_msg'
              },
              {
                name: this.$t('asm_case_order_detail.bao_yang_xiang_mu'),
                value: 'maintenance_item',
                role: 'work_order_maintain_project'
              },
              {
                name: this.$t('asm_case_order_detail.jyghlj'),
                value: 'suggest_replace_part',
                role: 'work_order_suggest_replace_part'
              },

              {
                name: this.$t('asm_case_order_detail.chu_li_ji_lu'),
                value: 'handle_record',
                role: 'work_order_handle_record'
              },
              {
                name: this.$t('asm_case_order_detail.gong_dan_gen_zong'),
                value: 'work_order_dynamic',
                role: 'work_order_order_tracking'
              },
            ];
          }
        }
      }


      const funcView = this.funcView;
      ret = ret.filter(item => funcView[item.role]);

      return ret;
    },
    curProductImg() {
      if (this.imgList.length) {
        return this.imgList[0].url;
      }
      return '';
    },
  },
  watch: {
    tabData(val, oldValue) {
      if (val && val.length && val.length !== oldValue.length) {
        this.initTabIndex();
      }
    },
    // fix: 从案例详情跳转工单详情时，页面不刷新
    $route(val) {
      if (val.meta && val.meta.keep === 'caseOrderDetail') {
        this.init();
      }
    },
  },
  filters: {},
  directives: {},
  methods: {
    // 开始返工
    onStartRework() {
      const info = this.info;
      const subStr = this.$t('asm_case_order_detail.kai_shi_fan_gong');
      const title = `${subStr}（${info.bodyNum}）`;
      this.startReworkModel = {
        title,
        data: info
      };
      this.startReworkVisible = true;
    },
    // 现场解决
    onsiteSolve() {
      const cfTips = this.$t('asm_case_order_detail.qdxgwshrydcjj');
      this.$showConfirm(cfTips).then(() => {
        const orderTechnicianId = this.info.orderTechnicianId;
        const reqUrl = `${apis.workOrderOptUpdateServiceMethod}/${orderTechnicianId}`;
        this.$postJSON(reqUrl).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.getInfo();
        });
      });
    },
    async timeOut(ms) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, ms);
      });
    },
    // 如果是返工工单的接单功能，要按顺序调用：已接单-已出发-已到达
    async acceptReworkOrder() {
      const workOrderId = this.workOrderId;
      // 已接单
      await this.$postJSON(`${apis.WorkOrderOptConfirmOrder}/${workOrderId}`);
      // 手动延迟，保证后端的顺序
      await this.timeOut(1100);
      // 出发
      await this.$postJSON(apis.WorkOrderOptSetOut, { workOrderId });
      await this.timeOut(1100);
      // 到达
      await this.$postJSON(apis.WorkOrderOptArrivals, { workOrderId });
      this.$message({
        message: this.$t('Common.com_handle_success'),
        type: 'success',
      });
      this.getInfo();
      this.Bus.$emit('caseOrderChange');
    },

    // 接单-工单
    async acceptWorkOrder() {
      if (this.isReworkOrder) {
        this.acceptReworkOrder();
      } else {
        const reqUrl = `${apis.WorkOrderOptConfirmOrder}/${this.workOrderId}`;
        this.$postJSON(reqUrl, {}, true).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.getInfo();
          this.Bus.$emit('caseOrderChange');
        });
      }

    },
    // 转派工单-工单
    transferWorkOrder() {
      this.assignWorkOrderModel = {
        title: this.$t('asm_case_order_detail.zhuan_pai_gong_dan'),
        data: this.info,
      };
      this.isTransfer = true;
      this.assignWorkOrderVisible = true;
    },
    // 质量反馈-工单
    feedBackWorkOrder() {
      if (this.isExistPartReplace) {
        this.feedBackModel = {
          title: this.$t('asm_case_order_detail.zhi_liang_fan_kui'),
          data: this.info,
          type: 'add'
        };
        this.feedBackVisible = true;
      } else {
        this.feedBackModel1 = {
          title: this.$t('asm_case_order_detail.zhi_liang_fan_kui'),
          data: this.info,
          type: 'workOrderAdd'
        };
        this.feedBackVisible1 = true;
      }

    },
    // 关闭工单
    closeWorkOrder() {
      this.acceptanceCommentsModel = {
        title: this.$t('asm_case_order_detail.zhuan_zhi_zhu_guan'),
        type: 'closeWorkOrder',
        data: this.info,
      };
      this.acceptanceCommentsVisible = true;
    },
    // 分派工单-案例订单
    assignWorkOrder() {
      this.assignWorkOrderModel = {
        title: this.$t('asm_case_order_detail.fpgcs'),
        data: this.info,
      };
      this.isTransfer = false;
      this.assignWorkOrderVisible = true;
    },
    reAssignWorkOrder() {
      this.assignWorkOrderModel = {
        title: this.$t('asm_case_order_detail.zai_ci_fen_pai'),
        data: this.info,
        type: 'redispatch'
      };
      this.isTransfer = false;
      this.assignWorkOrderVisible = true;
    },
    // 受理
    onAccept() {
      this.acceptanceCommentsModel = {
        title: this.$t('asm_case_order_detail.shou_li_yi_jian'),
        type: 'acceptCase',
        data: this.info,
      };
      this.acceptanceCommentsVisible = true;
    },
    // 关闭
    onClose() {
      this.acceptanceCommentsModel = {
        title: this.$t('asm_case_order_detail.qu_xiao_ding_dan'),
        type: 'closeCase',
        data: this.info,
      };
      this.acceptanceCommentsVisible = true;
    },
    onSuccess() {
      this.getInfo();
      this.Bus.$emit('caseOrderChange');
    },
    getDefaultInfo() {
      return {
        // 优先级
        priority: '',
        caseOrderCode: '',
        workOrderCode: '',
        caseOrderType: '',
        orgName: '',
        creator: '',
        contactPhone: '',
        caseOrderSource: '',
        contactName: '',
        projectContactName: '',
        projectContactPhone: '',
        technicianOrgName: '',
        technicianName: '',
        technicianPhone: '',
        caseOrderState: '',

        createMode: '',
        gmtCreate: '',
        planFinishTime: '',
        caseOrderDesc: '',
        productCode: '',
        productBrand: '',
        bodyNum: '',
        modemSn: '',
        contractNo: '',
        useAddress: '',
        locationName: '',
        agentCoName: '',
        afterServiceName: '',
        customerName: '',
        orderDeviceId: '',
      };
    },
    getImgList() {
      if (!this.info.productCodeId) {
        return;
      }
      this.$getFileList({ bizId: this.info.productCodeId, bizType: 'dms.product.icon' }).then((list) => {
        this.imgList = list;
      });
    },
    initTabIndex() {
      if (this.tabData.length) {
        this.tabIndex = this.tabData[0].value;
      }
    },
    getIsExistPartReplace() {
      this.$getJSON(apis.workOrderPartIsExistPartReplace, {
        workOrderId: this.workOrderId
      }, true).then((res) => {
        this.isExistPartReplace = res.data;
      });
    },
    getInfo() {
      this.initTabIndex();
      this.info = getDefaultInfo();
      const reqUrl = this.orderType === 'caseOrder' ? `${apis.caseOrderInfo}/${this.caseOrderId}` : `${apis.WorkOrderDetail}/${this.workOrderId}`;
      this.$getJSON(reqUrl, {}, true).then((res) => {

        this.info = res.data;
        this.getImgList();

        this.getIsExistPartReplace();

      });
    },
    // 优先级修改
    onPriorityChange(data) {
      const reqData = {
        priority: data.value,
        caseOrderId: this.info.caseOrderId,
      };

      this.$postJSON(apis.caseOrderUpdatePriority, reqData, true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.Bus.$emit('caseOrderChange');
      });
    },
    init() {
      this.caseOrderId = this.getJump('caseOrderId');
      this.workOrderId = this.getJump('workOrderId');
      this.orderType = this.getJump('orderType') || 'caseOrder';
      this.caseOrderType = this.getJump('caseOrderType') || '10';
      this.isPersonal = Boolean(this.getJump('isPersonal'));

      if (this.orderType === 'caseOrder') {
        this.getFuncView('/workorder/caseOrderDetail');
      } else {
        this.getFuncView('/workorder/workOrderDetail');
      }

      this.getInfo();
    },
  },
  created() { },
  mounted() {
    this.init();
  },
  activated() {

  },
};
</script>

<style lang="scss" scoped>
.case-order-detail {
  padding: 0 16px 16px;

  display: flex;
  flex-direction: column;

  > .header {
    padding: 24px 0 16px 0;
    height: 68px;
    overflow: hidden;
    .icon {
      font-size: 16px;
      float: left;
      line-height: 30px;
      font-weight: bold;
    }
    .title {
      float: left;
      margin-left: 18px;
      color: #394668;
      font-size: 18px;
      line-height: 32px;
      &:hover {
        cursor: pointer;
      }
    }

    .btn-content {
      float: right;
    }
  }

  > .user-info-content {
    background: #fff;
    padding-bottom: 16px;

    .text-left {
      text-align: left;
    }

    .text-right {
      text-align: right;
    }

    > .header {
      overflow: hidden;
      height: 86px;
      padding: 0 24px;
      display: flex;

      .param-item {
        > .key {
          font-size: 12px;
          color: #6c757d;
          line-height: 18px;
        }
        > .val {
          color: #495057;
          font-size: 12px;
          font-weight: bold;
          margin-top: 4px;
          line-height: 24px;
        }
      }

      .user-info {
        float: left;
        margin-top: 24px;

        .user-icon {
          $r: 46px;
          width: $r;
          height: $r;
          float: left;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-image: url('~@/images/layout/head.png');
        }
        .user-text-info {
          float: left;
          margin-left: 22px;
        }
      }

      .param-content {
        flex: 1;
        width: 0;
        overflow-x: auto;
        margin-right: 27px;
        margin-top: 24px;
        .param-list {
          overflow: hidden;
          float: right;
          > .item {
            float: left;
            margin-left: 50px;
            margin-bottom: 10px;
          }
        }
      }
    }

    > .bar-content {
      padding: 0 24px;
    }

    > .order-desc {
      overflow: hidden;
      padding: 0 32px;
      margin-top: 16px;
      display: flex;
      color: #495057;
      font-size: 12px;
      > .val {
        flex: 1;
        word-break: break-all;
      }
    }
  }

  > .content {
    flex: 1;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    margin-top: 16px;

    .device-param {
      width: 300px;
      background: #fff;
      padding: 0 24px;
      float: left;
      margin-right: 16px;
      overflow-y: auto;
      padding-bottom: 30px;

      .header {
        height: 40px;
        position: relative;
        .device-sn {
          float: left;
          color: #495057;
          font-size: 14px;
          font-weight: bold;
          line-height: 24px;
          margin-top: 16px;
          margin-left: -8px;
        }
      }

      .device-img {
        &.gray {
          background: #f5f5f5;
        }
        $r: 160px;
        width: $r;
        height: $r;
        margin: 24px auto 0 auto;
        position: relative;

        &.offline {
          /** 图片去色 */
          -webkit-filter: grayscale(100%);
          -moz-filter: grayscale(100%);
          -ms-filter: grayscale(100%);
          -o-filter: grayscale(100%);
          filter: grayscale(100%);
          filter: gray;
        }

        > img {
          position: absolute;
          max-width: 100%;
          max-height: 100%;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }
      }

      .param-detail {
        margin-top: 24px;
        color: #6c757d;
        font-size: 12px;
        > li {
          padding: 8px 0 7px 0;
          border-bottom: 1px solid #eef2f7;
          .content {
            overflow: hidden;
            line-height: 18px;
            .key {
              width: 40%;
              float: left;
            }
            .val {
              float: right;
              width: 60%;
              text-align: right;
              word-break: break-all;
            }
          }
          .adress {
            margin-top: 6px;
            color: #98a6ad;
            line-height: 17px;
          }
        }
      }
    }

    .tab-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      background: #fff;

      .tab-content {
        flex: 1;
        overflow-y: auto;
      }
    }
  }
}
</style>
